import { render } from "./404page.vue?vue&type=template&id=d5171c00"
const script = {}

import exportComponent from "/home/runner/work/policies/policies/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__